[
    {
      "countryids": [ 4, 6, 7, 9, 12, 14, 22, 25, 26, 27, 31, 32, 33],
      "patterns": [ "^\\d{5}$" ],
      "minlength": 5,
      "maxlength": 5,
      "message": " 11111"
    },
    {
      "countryids": [ 2 ],
      "patterns": [ "(^[A-CEGHJ-NPR-TVXY][0-9][A-Z]$)|(^[A-CEGHJ-NPR-TVXY][0-9][A-Z][0-9][A-Z][0-9]$)" ],
      "minlength": 3,
      "maxlength": 6,
      "message": " A1A1A1 or A1A"
    },
    {
      "countryids": [ 3, 11, 16, 19, 21, 23, 34],
      "patterns": [ "^\\d{6}$" ],
      "minlength": 6,
      "maxlength": 6,
      "message": " 111111"
    },
    {
      "countryids": [ 5, 13, 17, 18, 28, 30 ],
      "patterns": [ "^\\d{4}$" ],
      "minlength": 4,
      "maxlength": 4,
      "message": " 1111"
    },
    {
      "countryids": [ 29 ],
      "patterns": [ "(^\\d{4}[A-Z]{2}$)|(^\\d{4}[ ][A-Z]{2}$)" ],
      "minlength": 6,
      "maxlength": 7,
      "message": " 1111AA or 1111 AA"
    },
    {
      "countryids": [ 8 ],
      "patterns": [ "(^\\d{5}-\\d{3}$)|(^\\d{5}$)" ],
      "minlength": 5,
      "maxlength": 9,
      "message": " 11111-111 or 11111"
    },
    {
      "countryids": [ 15 ],
      "patterns": [ "(^\\d{3}[ ]\\d{2}$)|(^\\d{5}$)" ],
      "minlength": 5,
      "maxlength": 6,
      "message": " 111 11 or 11111"
    },
    {
      "countryids": [ 1 ],
      "patterns": [ "(^[G][I][R]{0,1}[A][A]|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW])[0-9][ABD-HJLNP-UW-Z]{2}$)|(^[G][I][R]{0,1}[A][A]|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW])$)" ],
      "minlength": 2,
      "maxlength": 7,
      "message": " AA1A,AA1A1AA,A1A,A1A1AA,A1,A11AA,A11,A111AA,AA1,AA11AA,AA11 or AA111AA"
    },
    {
      "countryids": [ 24 ],
      "patterns": [ "(^\\d{2}-\\d{3}$)|(^\\d{5}$)" ],
      "minlength": 5,
      "maxlength": 6,
      "message": " 11-111"
    },
    {
      "countryids": [ 20 ],
      "patterns": [ "(^\\d{3}-\\d{4}$)|(^\\d{7}$)" ],
      "minlength": 7,
      "maxlength": 8,
      "message": " 111-1111 or 1111111"
    },
    {
      "countryids": [ 10 ],
      "patterns": [ "(^[A-Z]\\d{4}$)|(^[A-Z]\\d{4}[A-Z]{3}$)" ],
      "minlength": 5,
      "maxlength": 8,
      "message": " A1111"
    }
  ]

